import { createReducer, on } from '@ngrx/store';
import {
  loadPrinter,
  loadPrinterSuccess,
  loadPrinterFailure,
  connectPrinter,
  connectPrinterSuccess,
  connectPrinterFailure,
  ignorePrinter,
  resetPrinterIgnore
} from './printer.actions';

export const printerFeatureKey = 'printer';

export interface PrinterState {
  printer: any;
  isConnected: boolean;
  error: any;
  loading: boolean;
  isIgnored: boolean;
}

// Función para obtener el estado inicial, comprobando localStorage
function getInitialState(): PrinterState {
  const isIgnored = localStorage.getItem('printerIgnored') === 'true';

  return {
    printer: null,
    isConnected: false,
    error: null,
    loading: false,
    isIgnored: isIgnored
  };
}

export const initialState: PrinterState = getInitialState();

// Función para depurar el estado
export const selectPrinterState = (state: { [printerFeatureKey]: PrinterState }) => {
  console.log('Estado actual de la impresora:', state[printerFeatureKey]);
  return state[printerFeatureKey];
};

export const reducer = createReducer(
  initialState,
  on(loadPrinter, (state) => ({ ...state, loading: true })),
  on(loadPrinterSuccess, (state, { printer }) => ({
    ...state,
    printer: printer,
    isConnected: true,
    loading: false,
    error: null
  })),
  on(loadPrinterFailure, (state, { error }) => ({
    ...state,
    error: error,
    loading: false,
    isConnected: false
  })),
  on(connectPrinter, (state) => ({ ...state, loading: true })),
  on(connectPrinterSuccess, (state, { printer }) => ({
    ...state,
    printer: printer,
    isConnected: true,
    loading: false,
    error: null
  })),
  on(connectPrinterFailure, (state, { error }) => ({
    ...state,
    error: error,
    loading: false,
    isConnected: false
  })),
  on(ignorePrinter, (state) => ({
    ...state,
    isIgnored: true,
    isConnected: false,
    // Store that printer was ignored in localStorage
    ...(() => { localStorage.setItem('printerIgnored', 'true'); return {}; })()
  })),
  on(resetPrinterIgnore, (state) => ({
    ...state,
    isIgnored: false,
    // Remove the ignored state from localStorage
    ...(() => { localStorage.removeItem('printerIgnored'); return {}; })()
  }))
);
